

import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
interface WelcomeButtonsProps {
  onGetStarted: () => void;
  onLogin: () => void;
}
const WelcomeButtons = ({
  onGetStarted,
  onLogin
}: WelcomeButtonsProps) => {
  return <motion.div className="w-full max-w-xs space-y-4" initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 0.7,
    duration: 0.5
  }}>
      <Button onClick={onGetStarted} className="w-full py-6 text-lg font-medium bg-white text-purple-700 hover:bg-gray-100">Get Started - Its Free</Button>
      
      <div className="text-center">
        <button onClick={onLogin} className="text-white text-lg underline">
          I already have an account
        </button>
      </div>
    </motion.div>;
};
export default WelcomeButtons;
